/* Loaded from two places:
     - snippets/header-actions.liquid  (the cart drawer in the header)
     - snippets/cart-upsells.liquid    (the cart page)
   Horizon does not render the drawer on /cart, so the header's copy of this
   script never ran there. The <cart-upsell> element was in the page but was
   never upgraded, so no Swiper instance sized the slides and each card fell
   back to Swiper's base `.swiper-slide { width: 100% }`.

   The whole file is wrapped in an IIFE with an early return because a classic
   script that executes twice throws on the top-level `class` declaration
   before any guard inside the file could run. */
(function () {
  if (customElements.get('cart-upsell')) return;

  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
      document.addEventListener('cart:update', this.onCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.onCartUpdate);
      this.destroySlider();
    }

    onCartUpdate = () => {
      requestAnimationFrame(() => {
        this.destroySlider();
        this.initSlider();

        this.querySelectorAll(".junip-product-summary")?.forEach(el => {
          const match = junipData.find(item => item.productId === el.dataset.productId);

          if (match) {
            el.innerHTML = match.html;
          }
        });
      });
    };

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSlider() {
    const index = this.getAttribute("data-index");
    const slider = this.querySelector(`[js-cart-upsell-${index}-slider]`);

    if (!slider) return;
    if (slider.classList.contains('swiper-initialized')) return;

    let sliderSettings = {};
    if (index == "1") {
      sliderSettings = {
        slidesPerView: "1",
        spaceBetween: 16,
        loop: false,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true
        },
        breakpoints: {
          0: { slidesPerView: 1.0701 },
          768: { slidesPerView: 1.232 },
          992: { slidesPerView: 1.232 },
        },
      };
    }
    if (index == "2") {
      sliderSettings = {
        slidesPerView: "1",
        spaceBetween: 16,
        loop: false,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true
        },
        breakpoints: {
          0: { slidesPerView: 1.72 },
          768: { slidesPerView: 1.232 },
          992: { slidesPerView: 2.705 },
        },
      };
    }

    this.swiper = new Swiper(slider, sliderSettings);
  }
  }

  customElements.define('cart-upsell', CartUpsell);

  window.junipData = window.junipData || [];

  const observer = new MutationObserver(() => {
    document.querySelectorAll("cart-drawer-component .junip-product-summary")
      .forEach(el => {
        if (!el.dataset.observing) {
          el.dataset.observing = "true";

          new MutationObserver(() => {
            const productId = el.dataset.productId;
            const html = el.innerHTML.trim();

            if (!html) return;

            const existing = window.junipData.find(item => item.productId === productId);

            if (existing) {
              existing.html = html;
            } else {
              window.junipData.push({ productId, html });
            }

          }).observe(el, {
            childList: true,
            subtree: true
          });
        }
      });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
